export enum NodeTypeEnum {
  process = 'process',
  custom = 'custom',
  decision = 'decision',
  end = 'end',
  fork = 'fork',
  join = 'join',
  start = 'start',
  task = 'task',
  transition = 'transition',
  subProcess = 'subProcess',
  ignore = 'ignore',
}
